<template>
  <div class="flex items-center">
    <IconExclamationCircleFilled class="mr-2 text-error" />
    <span> <slot /> </span>
  </div>
</template>
